'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _logo522x = require('./images/logo52@2x.png');

var _logo522x2 = _interopRequireDefault(_logo522x);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PrivacyPolicyCn = function (_React$Component) {
    _inherits(PrivacyPolicyCn, _React$Component);

    function PrivacyPolicyCn() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, PrivacyPolicyCn);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PrivacyPolicyCn.__proto__ || Object.getPrototypeOf(PrivacyPolicyCn)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            beianText: '京ICP备18016017号-7',
            companyEnName: 'Beijing Xiaowei Cloud Inc.',
            companyName: '北京小微云服科技有限公司',
            isOhos: false
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(PrivacyPolicyCn, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            document.title = '日历清单-隐私协议';

            if (window.location.hostname == 'weather.desktopcal.com') {
                this.setState({ beianText: '京ICP备16042173号-1', companyName: '北京云书科技有限公司', companyEnName: 'Beijing CloudStory, Inc.' });
            }

            var search = new URLSearchParams(location.search);

            var src = search.get("os");
            if (src == 'harmonyos') {
                this.setState({ isOhos: true });
            }
        }
    }, {
        key: 'render',
        value: function render() {

            return _react2["default"].createElement(
                'div',
                { className: 'web' },
                _react2["default"].createElement(
                    'div',
                    { className: 'header' },
                    _react2["default"].createElement(
                        'div',
                        { className: 'content' },
                        _react2["default"].createElement('img', { className: 'logo', src: _logo522x2["default"] }),
                        _react2["default"].createElement(
                            'div',
                            { className: 'left' },
                            '\u65E5\u5386\u6E05\u5355'
                        )
                    )
                ),
                _react2["default"].createElement(
                    'div',
                    { className: 'eula' },
                    _react2["default"].createElement(
                        'div',
                        { className: 'title' },
                        '\u65E5\u5386\u6E05\u5355\u9690\u79C1\u534F\u8BAE'
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'part' },
                        '\u672C\u534F\u8BAE\u66F4\u65B0\u4E8E2024\u5E748\u670821\u65E5'
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'part' },
                        '\u4FDD\u62A4\u60A8\u7684\u4E2A\u4EBA\u9690\u79C1\u89C6\u4E3A\u6211\u4EEC\u6700\u91CD\u8981\u7684\u5DE5\u4F5C\u4E4B\u4E00\u3002\u5728\u60A8\u4F7F\u7528\u6211\u4EEC\u7684\u8F6F\u4EF6\u4E4B\u524D\uFF0C\u8BF7\u60A8\u52A1\u5FC5\u8BA4\u771F\u9605\u8BFB\u4EE5\u4E0B\u58F0\u660E\u3002'
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'text' },
                        '\u300A\u65E5\u5386\u6E05\u5355\u300B\uFF08\u4EE5\u4E0B\u7B80\u79F0\u672C\u8F6F\u4EF6\uFF09\u4E3A\u4E86\u7ED9\u60A8\u63D0\u4F9B\u767B\u5F55\u548C\u540C\u6B65\u6570\u636E\u7684\u670D\u52A1\uFF0C\u672C\u8F6F\u4EF6\u53EF\u80FD\u4F1A\u4EE5\u4EE5\u4E0B\u63D0\u5230\u7684\u65B9\u5F0F\uFF0C\u5C06\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u63D0\u4EA4\u81F3\u6211\u4EEC\u7684\u6570\u636E\u670D\u52A1\u5668\u3002\u7136\u800C\uFF0C\u8BF7\u60A8\u653E\u5FC3\uFF0C\u6211\u4EEC\u4F1A\u4EE5\u6700\u9AD8\u7684\u5B89\u5168\u6807\u51C6\u5904\u7406\u8FD9\u4E9B\u4FE1\u606F\u3002\u6CA1\u6709\u60A8\u7684\u5141\u8BB8\uFF0C\u6211\u4EEC\u7EDD\u4E0D\u4F1A\u5C06\u8FD9\u4E9B\u4FE1\u606F\u516C\u5F00\uFF0C\u66F4\u4E0D\u4F1A\u63D0\u4F9B\u7ED9\u4EFB\u4F55\u7B2C\u4E09\u65B9\u3002'
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'part' },
                        '\u9690\u79C1\u4FDD\u62A4'
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'text' },
                        '\u5C0A\u91CD\u7528\u6237\u7684\u9690\u79C1\u662F\u6211\u4EEC\u4E00\u8D2F\u7684\u539F\u5219\u3002\u975E\u6CD5\u9662\u6216\u8005\u653F\u5E9C\u8981\u6C42\u7684\u60C5\u51B5\u4E0B\uFF0C\u6211\u4EEC\u5C06\u4FDD\u62A4\u7528\u6237\u9690\u79C1\u4E0D\u5411\u4EFB\u4F55\u7B2C\u4E09\u65B9\u4EE5\u53CA\u6211\u4EEC\u7684\u5408\u4F5C\u4F19\u4F34\u516C\u5F00\u3002\u4E3A\u4E86\u63D0\u5347\u6211\u4EEC\u8F6F\u4EF6\u7684\u6280\u672F\u6C34\u5E73\u3001\u7528\u6237\u4F53\u9A8C\u548C\u670D\u52A1\u6807\u51C6\uFF0C\u672C\u8F6F\u4EF6\u53EF\u80FD\u4F1A\u6536\u96C6\u548C\u4F7F\u7528\u90E8\u5206\u975E\u4E2A\u4EBA\u7684\u4FE1\u606F\uFF0C\u6216\u8005\u5C06\u90E8\u5206\u975E\u4E2A\u4EBA\u4FE1\u606F\u63D0\u4F9B\u7ED9\u7B2C\u4E09\u65B9\u5408\u4F5C\u4F19\u4F34\u4F7F\u7528\u3002'
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'part' },
                        '\u4FE1\u606F\u6536\u96C6'
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'text' },
                        '\u5F53\u60A8\u63A5\u53D7\u6211\u4EEC\u7684\u670D\u52A1\u6761\u6B3E\u5E76\u81EA\u613F\u4F7F\u7528\u6211\u4EEC\u7684\u670D\u52A1\u65F6\uFF0C\u672C\u8F6F\u4EF6\u53EF\u80FD\u4F1A\u6536\u96C6\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u8FD9\u4E9B\u4FE1\u606F\u5305\u62EC\uFF1A\u60A8\u7684\u59D3\u540D\u3001\u4F7F\u7528\u4F55\u79CD\u8BED\u8A00\u3001\u56FD\u5BB6\u3001e-mail\u3001\u7528\u6237ID\u3001OAID\u3001SN\u3001\u8BFB\u53D6\u5DF2\u5B89\u88C5\u5E94\u7528\u4FE1\u606F\u3002\u4E0A\u9762\u63D0\u53CA\u5230\u7684\u4FE1\u606F\u5C06\u5728\u60A8\u6CE8\u518C\u6D41\u7A0B\u548C\u7528\u6237\u504F\u597D\u8BBE\u7F6E\u9875\u9762\u88AB\u6211\u4EEC\u6536\u96C6\uFF0C\u6211\u4EEC\u5C06\u7528\u8FD9\u4E9B\u4FE1\u606F\u4E0E\u60A8\u53D6\u5F97\u8054\u7CFB\uFF0C\u5E76\u4E14\u53EF\u80FD\u7ED9\u60A8\u53D1\u9001\u7279\u5B9A\u7684\u670D\u52A1\u4FE1\u606F\uFF0C\u4F8B\u5982\u901A\u77E5\u3001\u6280\u672F\u7684\u670D\u52A1\u4E8B\u4EF6\u3001\u5B89\u5168\u63D0\u9192\u3002\u6211\u4EEC\u5076\u5C14\u4E5F\u4F1A\u53D1\u9001\u4E00\u4E9B\u4EA7\u54C1\u8C03\u67E5\u3001\u4EA7\u54C1\u4FC3\u9500\u4FE1\u606F\u3002 \u60A8\u4E0B\u8F7D\uFF0C\u5B89\u88C5\u5E76\u4F7F\u7528\u6211\u4EEC\u7684\u8F6F\u4EF6\u5C06\u88AB\u89C6\u4E3A\u5DF2\u7ECF\u540C\u610F\u6211\u4EEC\u4F7F\u7528\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u3002'
                    ),
                    this.state.isOhos ? _react2["default"].createElement(
                        'div',
                        { className: 'text' },
                        '\u76F8\u673A\u6743\u9650 ohos.permission.CAMERA\u3002\u6743\u9650\u529F\u80FD\u8BF4\u660E\uFF1A\u5141\u8BB8\u5E94\u7528\u4F7F\u7528\u76F8\u673A\u3002\u4F7F\u7528\u573A\u666F\u548C\u76EE\u7684\uFF1A\u5728\u7528\u6237\u9009\u62E9\u901A\u8FC7\u62CD\u7167\u4E0A\u4F20\u5934\u50CF\u65F6\uFF0C\u65E5\u5386\u6E05\u5355\u9700\u8981\u5728\u672C\u5730\u8BBF\u95EE\u60A8\u7684\u76F8\u673A\uFF0C\u62CD\u6444\u65F6\uFF0C\u4EC5\u53EF\u8BBF\u95EE\u60A8\u62CD\u6444\u5B8C\u6210\u540E\u7684\u5185\u5BB9\uFF0C\u4E0D\u4F1A\u8BFB\u53D6\u76F8\u673A\u53D6\u666F\u5185\u5BB9'
                    ) : _react2["default"].createElement(
                        'div',
                        { className: 'text' },
                        '\u8BFB\u53D6\u526A\u5207\u677F\u4FE1\u606F ohos.permission.READ_PASTEBOARD\u3002\u6743\u9650\u529F\u80FD\u8BF4\u660E\uFF1A\u5141\u8BB8\u5E94\u7528\u8BFB\u53D6\u526A\u5207\u677F\u4FE1\u606F\u3002\u4F7F\u7528\u573A\u666F\u548C\u76EE\u7684\uFF1A\u5728\u7528\u6237\u957F\u6309\u7F16\u8F91\u6846\u5E76\u9009\u62E9\u7C98\u8D34\u65F6\uFF0C\u65E5\u5386\u6E05\u5355\u9700\u8981\u5728\u672C\u5730\u8BBF\u95EE\u60A8\u7684\u526A\u5207\u677F\uFF0C\u7528\u6237\u53EF\u81EA\u884C\u9009\u62E9\u662F\u5426\u6388\u4E88\u6743\u9650\u3002'
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'part' },
                        '\u540C\u6B65\u6570\u636E'
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'text' },
                        '\u60A8\u7684\u4E2A\u4EBA\u540C\u6B65\u6570\u636E\uFF0C\u6211\u4EEC\u4F1A\u975E\u5E38\u91CD\u89C6\u9690\u79C1\u4FDD\u62A4\u3002\u6211\u4EEC\u53EA\u505A\u4E3A\u6570\u636E\u5B58\u50A8\u5728\u670D\u52A1\u5668\u4E0A\uFF0C\u4E3A\u60A8\u4FDD\u5B58\u5386\u53F2\u6570\u636E\uFF0C\u4E0D\u505A\u4EFB\u4F55\u7684\u5176\u4ED6\u7528\u9014\u3002\u5982\u679C\u60A8\u9700\u8981\u5220\u9664\u60A8\u7684\u540C\u6B65\u6570\u636E\uFF0C\u8BF7\u53D1\u90AE\u4EF6\u7ED9\u6211\u4EEC\uFF0C\u6211\u4EEC\u4F1A\u5C06\u60A8\u7684\u6570\u636E\u5220\u9664\u3002'
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'part' },
                        '\u8D26\u53F7\u767B\u5F55\u3001\u6CE8\u518C\u3001\u66F4\u6B63\u53CA\u6CE8\u9500'
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'text' },
                        '\u60A8\u767B\u5F55\u6216\u6CE8\u518C\u6210\u4E3A\u672C\u8F6F\u4EF6\u7528\u6237\u540E\uFF0C\u672C\u8F6F\u4EF6\u4F1A\u8BF7\u6C42\u4F60\u7684\u5B58\u50A8\u6743\u9650\uFF0C\u5982\u62D2\u7EDD\u63D0\u4F9B\u5B58\u50A8\u6743\u9650\uFF0C\u60A8\u5C06\u65E0\u6CD5\u6B63\u5E38\u4F7F\u7528\u8D26\u53F7\u4EE5\u53CA\u540C\u6B65\u6570\u636E\u529F\u80FD\u3002'
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'text' },
                        '\u60A8\u53EF\u4EE5\u901A\u8FC7\u5BA2\u670D\u65B9\u5F0F\uFF08\u53D1\u9001\u90AE\u4EF6\u5230 service@xiaoweiyunfu.com\uFF09\u7533\u8BF7\u66F4\u6B63\u3001\u5220\u9664\u4E2A\u4EBA\u4FE1\u606F\u53CA\u6CE8\u9500\u60A8\u7684\u5E10\u53F7\uFF0C\u6211\u4EEC\u627F\u8BFA15\u4E2A\u5DE5\u4F5C\u65E5\u5E2E\u60A8\u5904\u7406\u5B8C\u6210\u3002\u5F53\u60A8\u6CE8\u9500\u5E10\u53F7\u540E\uFF0C\u60A8\u5C06\u65E0\u6CD5\u518D\u4EE5\u8BE5\u5E10\u53F7\u767B\u5F55\u548C\u4F7F\u7528\u6211\u4EEC\u7684\u4EA7\u54C1\u4E0E\u670D\u52A1\u3002'
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'text' },
                        '\u8BE5\u5E10\u53F7\u4E0B\u7684\u5185\u5BB9\u3001\u4FE1\u606F\u3001\u6570\u636E\u3001\u8BB0\u5F55\u7B49\u5C06\u4F1A\u88AB\u5220\u9664\u6216\u533F\u540D\u5316\u5904\u7406\uFF08\u4F46\u6CD5\u5F8B\u6CD5\u89C4\u53E6\u6709\u89C4\u5B9A\u6216\u76D1\u7BA1\u90E8\u95E8\u53E6\u6709\u8981\u6C42\u7684\u9664\u5916\uFF0C\u5982\u4F9D\u636E\u300A\u4E2D\u534E\u4EBA\u6C11\u5171\u548C\u56FD\u7F51\u7EDC\u5B89\u5168\u6CD5\u300B\u89C4\u5B9A\uFF0C\u60A8\u7684\u7F51\u7EDC\u64CD\u4F5C\u65E5\u5FD7\u5C06\u81F3\u5C11\u4FDD\u7559\u516D\u4E2A\u6708\u7684\u65F6\u95F4\uFF09\u3002\u5E10\u53F7\u6CE8\u9500\u5B8C\u6210\u540E\uFF0C\u5C06\u65E0\u6CD5\u6062\u590D\u3002'
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'part' },
                        '\u81EA\u542F\u52A8\u548C\u5173\u8054\u542F\u52A8'
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'text' },
                        '\u5F53\u60A8\u4F7F\u7528\u672C\u8F6F\u4EF6\u7684\u95F9\u949F\u670D\u52A1\u529F\u80FD\u65F6\uFF0C\u4E3A\u4E86\u4FDD\u8BC1\u5728\u60A8\u8BBE\u5B9A\u7684\u65F6\u95F4\u51C6\u65F6\u63D0\u9192\u60A8\uFF0C\u6211\u4EEC\u9700\u8981\u4F7F\u7528\u81EA\u542F\u52A8\u670D\u52A1\u4EE5\u4FBF\u95F9\u949F\u63D0\u9192\u80FD\u6B63\u5E38\u63D0\u9192\uFF0C\u5982\u60A8\u60F3\u5173\u6389\u81EA\u542F\u52A8\u529F\u80FD\uFF0C\u53EF\u80FD\u4F1A\u5BFC\u81F4\u65E0\u6CD5\u6B63\u5E38\u63D0\u9192\u3002\u60A8\u53EF\u4EE5\u5728\u8BBE\u7F6E-\u5E94\u7528-\u81EA\u542F\u52A8\u7BA1\u7406\u4E2D\u5173\u95ED\u81EA\u542F\u52A8\u529F\u80FD\u3002'
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'part' },
                        '\u4F7F\u7528\u7B2C\u4E09\u65B9SDK'
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'text' },
                        '\u4E3A\u4E86\u4FDD\u969C\u5E73\u53F0\u7684\u8FD0\u8425\u7A33\u5B9A\u5B89\u5168\uFF0C\u6211\u4EEC\u4F7F\u7528\u53CB\u76DF+SDK\uFF0C\u5728\u60A8\u6388\u6743\u540C\u610F\u540E\uFF0C\u53CB\u76DF+SDK\u4F1A\u5728\u540E\u53F0\u8BBF\u95EE\u60A8\u8BBE\u5907\u4FE1\u606F\uFF08IMEI/\u8BBE\u5907\u5E8F\u5217\u53F7/OAID/MEID/Mac\u5730\u5740/Android ID/IDFA/OPENUDID/GUID/SIM\u5361/IMSI/\u5730\u7406\u4F4D\u7F6E/\u5DF2\u5B89\u88C5APP\u4FE1\u606F\u7B49\uFF09\u3002\u5982\u4E0D\u6388\u6743\uFF0C\u6709\u53EF\u80FD\u4F1A\u5F71\u54CD\u670D\u52A1\u7684\u5B89\u5168\u6027\u4EE5\u53CA\u60A8\u53EF\u80FD\u65E0\u6CD5\u5F97\u5230\u4F18\u8D28\u7684\u7528\u6237\u4F53\u9A8C\u3002\u60A8\u53EF\u4EE5\u8BBF\u95EE https://www.umeng.com/policy \u4E86\u89E3\u3010\u53CB\u76DF+\u3011\u9690\u79C1\u6743\u653F\u7B56\u3002'
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'text' },
                        '\u4E3A\u4E86\u7528\u6237\u80FD\u5B89\u5168\u5FEB\u901F\u7684\u767B\u5F55\uFF0C\u6211\u4EEC\u5728\u8F6F\u4EF6\u91CC\u63A5\u5165\u4E86\u5FAE\u4FE1\u767B\u5F55\uFF0C\u4F7F\u7528\u5FAE\u4FE1\u5F00\u53D1\u5E73\u53F0SDK\u548Ccom.jarvan.fluwx\uFF0C\u5FAE\u4FE1\u5F00\u53D1\u5E73\u53F0SDK\u548Ccom.jarvan.fluwx\u4F1A\u8BBF\u95EE\u60A8\u7684\u5E94\u7528\u5B89\u88C5\u5217\u8868\u3002\u5982\u4E0D\u6388\u6743\uFF0C\u5C06\u4E0D\u80FD\u5FEB\u6377\u767B\u5F55\u3002\u60A8\u53EF\u4EE5\u8BBF\u95EE https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/RYiYJkLOrQwu0nb8 \u4E86\u89E3\u5FAE\u4FE1\u5F00\u53D1\u5E73\u53F0 \u9690\u79C1\u653F\u7B56'
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'text' },
                        '\u7531\u652F\u4ED8\u5B9D\u63D0\u4F9B\u7B2C\u4E09\u65B9\u652F\u4ED8\u529F\u80FD\uFF0C\u6211\u4EEC\u5728\u8F6F\u4EF6\u91CC\u63A5\u5165\u4E86\u652F\u4ED8\u5B9D\uFF0C\u7528\u4E8E\u652F\u4ED8VIP\u4F1A\u5458\u5347\u7EA7\uFF0C\u4F7F\u7528\u652F\u4ED8\u5B9D\u5F00\u53D1\u5E73\u53F0SDK\uFF08com.alipay\uFF09\uFF0C\u652F\u4ED8\u5B9D\u5F00\u53D1\u5E73\u53F0SDK\uFF08com.alipay\uFF09\u4F1A\u83B7\u53D6\u60A8\u7684\u8BBE\u5907\u53F7\u3001IP\u5730\u5740\u3001\u8BBE\u5907\u8F6F\u4EF6\u4FE1\u606F\u3001\u8BBE\u5907\u8BC6\u522B\u7801\u3001\u8BBE\u5907\u8BC6\u522B\u7B26\u3001\u6240\u5728\u5730\u533A\u3001\u7F51\u7EDC\u4F7F\u7528\u4E60\u60EF\u3001\u8BBE\u5907\u76F8\u5173\u5E94\u7528\u4FE1\u606F\u4EE5\u53CA\u5176\u4ED6\u4E0E\u652F\u4ED8\u5B9D\u670D\u52A1\u76F8\u5173\u7684\u65E5\u5FD7\u4FE1\u606F\u3002\u60A8\u53EF\u4EE5\u8BBF\u95EE https://render.alipay.com/p/c/k2cx0tg8 \u4E86\u89E3\u9690\u79C1\u653F\u7B56'
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'part' },
                        '\u5F00\u53D1\u8005'
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'text' },
                        this.state.companyName
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'part' },
                        '\u8054\u7CFB\u6211\u4EEC'
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'text' },
                        '\u5982\u679C\u60A8\u6709\u5173\u4E8E\u672C\u9690\u79C1\u653F\u7B56\u7684\u4EFB\u4F55\u95EE\u9898\u6216\u7591\u8651\uFF0C\u8BF7\u53D1\u9001\u90AE\u4EF6\u5230\uFF1Aservice@xiaoweiyunfu.com'
                    ),
                    _react2["default"].createElement('div', { className: 'part' }),
                    _react2["default"].createElement('div', { className: 'part' })
                ),
                _react2["default"].createElement(
                    'div',
                    { className: 'footer' },
                    _react2["default"].createElement(
                        'div',
                        { className: 'content' },
                        _react2["default"].createElement(
                            'div',
                            { className: 'center' },
                            _react2["default"].createElement(
                                'div',
                                { className: 'left' },
                                _react2["default"].createElement(
                                    'div',
                                    { className: 'top' },
                                    '\u5BA2\u6237\u652F\u6301'
                                ),
                                _react2["default"].createElement(
                                    'div',
                                    { className: 'top1' },
                                    '\u5982\u679C\u60A8\u6709\u4EFB\u4F55\u610F\u89C1\u548C\u5EFA\u8BAE\uFF0C\u656C\u8BF7\u90AE\u4EF6\u8054\u7CFB\u6211\u4EEC',
                                    _react2["default"].createElement('br', null),
                                    'service@xiaoweiyunfu.com'
                                )
                            ),
                            _react2["default"].createElement('div', { className: 'left' })
                        )
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'copyright' },
                        _react2["default"].createElement(
                            'div',
                            { className: 'bottom' },
                            'Copyright \xA9 2021 ',
                            this.state.companyEnName,
                            '  ',
                            _react2["default"].createElement(
                                'a',
                                { className: 'link', href: 'privacypolicy' },
                                'Privacy Policy'
                            ),
                            ' / ',
                            _react2["default"].createElement(
                                'a',
                                { className: 'link', href: 'eula' },
                                'EULA'
                            ),
                            ' \xA0\xA0\xA0|\xA0\xA0\xA0 ',
                            _react2["default"].createElement(
                                'a',
                                { className: 'link', href: 'http://beian.miit.gov.cn/' },
                                ' ',
                                this.state.beianText
                            )
                        )
                    )
                )
            );
        }
    }]);

    return PrivacyPolicyCn;
}(_react2["default"].Component);

exports["default"] = PrivacyPolicyCn;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./PrivacyPolicyCn.js
// module id = 427
// module chunks = 0